import type { WorkflowNodeData } from '../types';
import { WorkflowNodeType } from '../types';
import {
  WorkflowNode,
  type WorkflowNodeHydration,
} from '../workflow-node-base';
import { AdHocAgentWorkflowNode } from './ad-hoc-agent-workflow-node';
import { AgentWorkflowNode } from './agent-workflow-node';
import { CompleteToolCallWorkflowNode } from './complete-tool-call-workflow-node';
import { ForEachWorkflowNode } from './for-each-workflow-node';
import { ToolCallWorkflowNode } from './tool-call-workflow-node';
import { FilterWorkflowNode } from './filter-workflow-node';
import { RunWorkflowWorkflowNode } from './run-workflow-workflow-node';
import { EmitEventWorkflowNode } from './emit-event-workflow-node';
import { MapperWorkflowNode } from './mapper-workflow-node';
import { DebounceWorkflowNode } from './debounce-workflow-node';
import { BucketWorkflowNode } from './bucket-workflow-node';
import { GroupByWorkflowNode } from './group-by-workflow-node';

export function createWorkflowNode(
  data: WorkflowNodeData,
  hydration: WorkflowNodeHydration
): WorkflowNode {
  switch (data.type) {
    case WorkflowNodeType.Agent:
      return AgentWorkflowNode.create(data, hydration);
    case WorkflowNodeType.AdHocAgent:
      return AdHocAgentWorkflowNode.create(data, hydration);
    case WorkflowNodeType.ToolCall:
      return ToolCallWorkflowNode.create(data, hydration);
    case WorkflowNodeType.ForEach:
      return ForEachWorkflowNode.create(data, hydration);
    case WorkflowNodeType.CompleteToolCall:
      return CompleteToolCallWorkflowNode.create(data, hydration);
    case WorkflowNodeType.Filter:
      return FilterWorkflowNode.create(data, hydration);
    case WorkflowNodeType.RunWorkflow:
      return RunWorkflowWorkflowNode.create(data, hydration);
    case WorkflowNodeType.EmitEvent:
      return EmitEventWorkflowNode.create(data, hydration);
    case WorkflowNodeType.Mapper:
      return MapperWorkflowNode.create(data, hydration);
    case WorkflowNodeType.Debounce:
      return DebounceWorkflowNode.create(data, hydration);
    case WorkflowNodeType.Bucket:
      return BucketWorkflowNode.create(data, hydration);
    case WorkflowNodeType.GroupBy:
      return GroupByWorkflowNode.create(data, hydration);
    default:
      return WorkflowNode.create(data, hydration);
  }
}
